<template>
    <div class="header-box-c">
        <div class="c-search">
            <img class="logo" alt="LOGO" src="@/assets/wap/common/logo.png" @click="gotoHome">
            <div class="c-search-box">
                <input class="c-search-input" v-model="search" placeholder="Laptop Computers" autocomplete="off"
                    @keyup.enter="toSearch">
                <img class="icon" alt="LOGO" src="@/assets/wap/icon/search.png" @click="toSearch">
            </div>
        </div>
        <div class="c-menu">
            <template v-for="item in menu">
                <div class="menu-item" :key="item.id" @click=select(item) :class="selectId == item.id ? 'active' : ''">
                    {{ item.title }}
                    <img v-if="item.children && item.children.length != 0" class="menu-icon" alt=""
                        src="@/assets/wap/icon/arrow.png">
                </div>
            </template>
            <div class="select-menu" :class="showMenu ? 'selectMenu-active' : ''">
                <div class="select-item" v-for="item in selectMenu" :key="item.id" @click=selectSub(item)>{{ item.title
                    }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { $data } from '@/setting/data';
import { gotoListPage } from '@/uitls/page';
export default {
    name: 'HeaderWAP',
    data() {
        return {
            search: '',
            menu: $data.menu,
            showMenu: false, // 是否显示菜单
            selectMenu: [],
            selectId: '',
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        select(item) {
            if (item.id == this.selectId) {
                this.showMenu = false;
                this.selectMenu = [];
                this.selectId = '';
            } else {
                this.selectId = item.id;
                if (item.children && item.children.length != 0) {
                    this.showMenu = true;
                    this.selectMenu = item.children;
                } else {
                    this.showMenu = false;
                    this.selectMenu = [];
                    this.selectId = '';
                    gotoListPage(item, this.$router);
                    this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': item.title });
                }
            }
        },
        selectSub(item) {
            this.showMenu = false;
            this.selectMenu = [];
            this.selectId = '';
            gotoListPage(item, this.$router);
            this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': item.title });
        },
        handleScroll() {
            const menu = document.querySelector('.c-menu');
            const menuPosition = menu.offsetTop;
            const scrollPosition = window.pageYOffset;

            if (scrollPosition > menuPosition) {
                menu.style.position = 'fixed';
                menu.style.top = '0';
            } else {
                menu.style.position = 'relative';
                menu.style.top = 'auto';
            }
        },
        toSearch() {
            if (this.search) {
                this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': 'Search' });
                this.$gioAction('searchSuccess', { 'jingtaititle_hk': this.search });
                let url = window.location.href;
                let path = url.includes('?')? `/search?key=${this.search}&${url.split('?')[1]}` : `/search?key=${this.search}`;
                const routeData = this.$router.resolve({
                    path: path
                });
                window.location.href = routeData.href;
            }
        },
        gotoHome() {
            this.$gioAction('navtopclick_hk', { 'jingtaititle_hk': 'Home' });
            let url = window.location.href;
            let path = '/';
            if (url.includes('?')) {
                const queryString = url.split('?')[1];
                const params = queryString.split('&');
                const filteredParams = params.filter(param => !param.startsWith('key='));
                if (filteredParams.length > 0) {
                    path = `/?${filteredParams.join('&')}`;
                }
            }
            const routeData = this.$router.resolve({
                path: path
            });
            window.location.href = routeData.href;
        }
    }
}
</script>
<style lang="scss" scoped>
.header-box-c {
    width: 100%;
    background: #ffffff;
}

.c-search {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 12vw;
    padding-left: 3.3vw;
    padding-right: 2.7vw;
    border-bottom: 1px solid #f2f2f2;

    .logo {
        display: block;
        width: 12.61vw;
        height: 7.15vw;
    }

    .c-search-box {
        position: relative;

        .c-search-input {
            display: block;
            width: 53.3vw;
            padding-right: 40px;
            border: 1px solid #D8D8D8;
            border-radius: 1.3vw;
            padding: 1.47vw 6.67vw 1.47vw 3.47vw;
            font-size: 3.7vw;

            &::placeholder {
                color: #999;
            }
        }

        .icon {
            position: absolute;
            top: 50%;
            right: 3.13vw;
            transform: translateY(-50%);
            width: 3.33vw;
            height: 3.33vw;
        }
    }
}

.c-menu {
    position: relative;
    z-index: 10;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 9.33vw;
    padding: 0 2.67vw;
    background: #ffffff;

    .menu-item {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 3.2vw;
        color: #444444;

        .menu-icon {
            position: relative;
            top: .5vw;
            width: 2vw;
            height: auto;
            margin-left: 0.9vw;
        }

        &.active {
            .menu-icon {
                transform: rotate(180deg);
            }
        }
    }

    .select-menu {
        visibility: hidden;
        position: absolute;
        top: 9.33vw;
        left: 0;
        box-sizing: border-box;
        width: 100%;
        height: auto;
        padding: 2.67vw;
        background: #ffffff;
        box-shadow: 0 1.27vw 0.6vw rgba(100, 101, 102, 0.12);
        opacity: 0;
        transform: translateY(-10px);
        transition: all .3s ease;

        .select-item {
            padding: 2vw 0;
            border-bottom: 1px solid #D8D8D8;
            font-size: 3.2vw;
            color: #444444;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    .selectMenu-active {
        visibility: visible;
        opacity: 1;
        transform: translateY(0);
    }
}
</style>